import { useEffect, useRef } from 'react';
import styles from './index.module.scss';

interface ConfirmModalProps {
    onCancel: (e: React.MouseEvent) => void;
    onConfirm: (e: React.MouseEvent) => void;
}

const ConfirmModal = ({ onCancel, onConfirm }: ConfirmModalProps) => {
    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                onCancel(event as unknown as React.MouseEvent);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onCancel]);

    return (
        <div className={styles.confirmOverlay}>
            <div ref={modalRef} className={styles.confirmModal}>
                <div className={styles.confirmMessage}>Are you sure you want to delete?</div>
                <div className={styles.confirmButtons}>
                    <button className={styles.cancelButton} onClick={onCancel}>
                        Cancel
                    </button>
                    <button className={styles.deleteButton} onClick={onConfirm}>
                        Delete
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmModal;  